<template>
  <div class="education">
    <div class="row">
      <div>{{ model.data.degree }} in {{ model.data.major }}</div>
      <div>{{ model.getDateString() }}</div>
    </div>
    <div class="row">
      <div>{{ model.data.school }}</div>
      <div>{{ model.data.location }}</div>
    </div>
  </div>
</template>

<script>

export default {
    name  : "Education",
    props : {
        model : {
            type : Object
        }
    }
};

</script>

<style scoped>

.education {
    margin:10px auto 30px;
    width:100%;
    max-width:350px;
}

.education > .row {
    display:flex;
    flex-wrap:nowrap;
    justify-content:space-between;
    align-items:flex-end;
}

.education > .row > * {
    font-size:12px;
    color:var(--main-gray);
}

.education > .row > *:first-child {
    font-weight:bold;
}

</style>
